export const mt5accountsPlatformSlugs = ['mt5', 'investmt5'];

export const mt5positionStatuses = ['open', 'closed'];
